export const LOGIN_PATH = "/login";
export const HOME_PATH = "/dashboard";

export interface AuthGateInput {
  configured: boolean;
  loading: boolean;
  hasSession: boolean;
  pathname: string;
  loginPath?: string;
  homePath?: string;
}

export type AuthGateDecision =
  | { kind: "render" }
  | { kind: "loading" }
  | { kind: "redirect"; to: string };

export function decideAuthGate(input: AuthGateInput): AuthGateDecision {
  const loginPath = input.loginPath ?? LOGIN_PATH;
  const homePath = input.homePath ?? HOME_PATH;

  if (!input.configured) {
    return { kind: "render" };
  }

  if (input.loading) {
    return { kind: "loading" };
  }

  const onLogin = input.pathname === loginPath;

  if (!input.hasSession) {
    return onLogin ? { kind: "render" } : { kind: "redirect", to: loginPath };
  }

  if (onLogin) {
    return { kind: "redirect", to: homePath };
  }

  return { kind: "render" };
}
